import { Component, ErrorInfo, ReactNode, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { RouterProvider } from "./router";
import "./styles.css";

class AppErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ui_render_failed", error.name, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="fatal-page">
          <span className="brand-mark">CV</span>
          <h1>Не удалось отобразить страницу</h1>
          <p>
            Результат сохранён. Обновите страницу или вернитесь в обзор —
            повторно запускать анализ не нужно.
          </p>
          <div>
            <button className="button primary" onClick={() => window.location.reload()}>
              Обновить страницу
            </button>
            <a className="button secondary" href="/app">Вернуться в обзор</a>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <RouterProvider>
        <App />
      </RouterProvider>
    </AppErrorBoundary>
  </StrictMode>
);
